document.addEventListener('DOMContentLoaded', () => {
  function normalize(str) {
    return (str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getSelectedVariantValue() {
    const checkedRadio = document.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      const value =
        checkedRadio.dataset.optionValue ||
        checkedRadio.getAttribute('data-option-value') ||
        checkedRadio.value ||
        '';
      if (value) return normalize(value);
    }

    const selects = document.querySelectorAll('select');
    for (const select of selects) {
      if (select.selectedIndex >= 0) {
        const txt = select.options[select.selectedIndex].textContent.trim();
        if (txt) return normalize(txt);
      }
    }

    return null;
  }

  function getMediaItems() {
    return document.querySelectorAll('[data-media-id]');
  }

  function getAltFromItem(item) {
    const img = item.querySelector('img[alt]');
    if (!img) return '';
    return (img.getAttribute('alt') || '').trim().toLowerCase();
  }

  function resetAll(items) {
    items.forEach((item) => {
      item.style.removeProperty('display');
    });
  }

  function filterMedia() {
    const selectedVariant = getSelectedVariantValue();
    const mediaItems = getMediaItems();

    if (!selectedVariant || !mediaItems.length) {
      resetAll(mediaItems);
      return;
    }

    let matchCount = 0;

    mediaItems.forEach((item) => {
      const alt = getAltFromItem(item);

      const visible =
        alt === '' ||
        alt === 'variant:all' ||
        alt === `variant:${selectedVariant}`;

      if (visible) matchCount++;
    });

    // sécurité : si aucune image ne correspond, on n'en masque aucune
    if (matchCount === 0) {
      resetAll(mediaItems);
      return;
    }

    mediaItems.forEach((item) => {
      const alt = getAltFromItem(item);

      const visible =
        alt === '' ||
        alt === 'variant:all' ||
        alt === `variant:${selectedVariant}`;

      item.style.display = visible ? '' : 'none';
    });
  }

  filterMedia();

  document.addEventListener('change', (event) => {
    if (
      event.target.matches('input[type="radio"]') ||
      event.target.matches('select')
    ) {
      setTimeout(filterMedia, 150);
    }
  });
});